export const PROTECTED_EARNINGS_RATE = 476699;

export default function rechner2025(wages, people) {
  let start = 156000;
  let addon = 0;
  let index = -1;

  if (wages < 9999) {
    wages *= 100;
  }

  if (people === 1) {
    start = 215000;
  }
  if (people === 2) {
    start = 247000;
  }
  if (people === 3) {
    start = 280000;
  }
  if (people === 4) {
    start = 312000;
  }
  if (people === 5) {
    start = 345000;
  }

  if (wages > PROTECTED_EARNINGS_RATE) {
    addon = wages - PROTECTED_EARNINGS_RATE;
    wages = PROTECTED_EARNINGS_RATE;
  }

  while (wages >= start) {
    start += 1000;
    index++;
  }

  if (index === -1) {
    return 0;
  }

  let startAmount = 350;
  let indexAmount = 700;

  if (people === 1) {
    startAmount = 489;
    indexAmount = 500;
  }
  if (people === 2) {
    startAmount = 149;
    indexAmount = 400;
  }
  if (people === 3) {
    startAmount = 231;
    indexAmount = 300;
  }
  if (people === 4) {
    startAmount = 33;
    indexAmount = 200;
  }
  if (people === 5) {
    startAmount = 56;
    indexAmount = 100;
  }

  return startAmount + index * indexAmount + addon;
}
